import { render, staticRenderFns } from "./GiveAllAccessConfirm.vue?vue&type=template&id=360be7ce&scoped=true"
import script from "./GiveAllAccessConfirm.vue?vue&type=script&lang=js"
export * from "./GiveAllAccessConfirm.vue?vue&type=script&lang=js"
import style0 from "./GiveAllAccessConfirm.vue?vue&type=style&index=0&id=360be7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360be7ce",
  null
  
)

export default component.exports